<template>
    <sky />
    <div class="aboutus">
        <div class="shadow"></div>
        <p class="t1">什么是数字藏品</p>
        <p class="t2">WHAT IS DIGITAL COLLECTIONS</p>
        <p class="t3">数字藏品是使用区块链技术进行唯一标识的经过数字化的特定作品、艺术品和商品。<br>
每个数字藏品都是唯一的，专属的，并且拥有独一无二的区块链凭证，<br>
承载着独特的体验和收藏价值。</p>
        <p class="t4">Digital collections are specific works, artworks and goods that have been digitized and uniquely identified by using <br/>blockchain technology. Each digital collection is unique, exclusive and has unique blockchain credentials, <br/>carrying a unique experience and collection value.</p>
    
    </div>
</template>
<script>
import Sky from '../components/Sky.vue'
export default {
  components: { Sky },
    
}
</script>
<style scoped>
@import url(~@/styles/aboutus.css);
</style>